/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { strategiesGetStrategy } from "../../funcs/strategiesGetStrategy.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetStrategyRequest$inboundSchema,
};

export const tool$strategiesGetStrategy: ToolDefinition<typeof args> = {
  name: "strategies-get-strategy",
  description: `Get a strategy by id

Returns a single strategy by id. Returns the same format as the list endpoint but for a single strategy.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await strategiesGetStrategy(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
